import React, { useState } from "react";
import Slider from "react-slick";
import "../assets/lifeatsg.css";

import team from '../assets/lifeatSG/team.JPG';
import team2 from '../assets/lifeatSG/team2.jpg';
import team3 from '../assets/lifeatSG/team3.jpg';
import who from '../assets/lifeatSG/who_we.jpg';
import foundersession from '../assets/lifeatSG/founder-session.jpeg';
import Strategy from '../assets/lifeatSG/strategy.JPG';
import qa from '../assets/lifeatSG/QA.jpg';
import builders from '../assets/lifeatSG/builders.JPG';
import meditation from '../assets/lifeatSG/meditation.JPG';
import culture from '../assets/lifeatSG/culture.jpeg';
import demohero from '../assets/lifeatSG/demo-hero.jpg';

import life1 from '../assets/lifeatSG/1.JPG';
import life2 from '../assets/lifeatSG/2.JPG';
import life3 from '../assets/lifeatSG/3.JPG';
import life4 from '../assets/lifeatSG/4.JPG';

import republic from '../assets/imgs/26th_jan.JPG';


import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Autoplay, Navigation } from "swiper/modules";
import "swiper/css/navigation";


import "swiper/css";
import "swiper/css/free-mode";
import { Link } from "react-router-dom";


const LifeAtSG = () => {

    const topRowRef = React.useRef(null);
    const bottomRowRef = React.useRef(null);

    const handleWheel = (e, ref) => {
        if (!ref.current) return;
        e.preventDefault();
        ref.current.scrollLeft += e.deltaY;
    };


    const topRowImages = [

        team,
        life1,
        team2,
        
        team3,
        republic,
        life2,
        who,
        foundersession,
    ];

    const bottomRowImages = [
        Strategy,
        qa,
        life3,
        builders,
        meditation,
        culture,
        life4,
    ];

    const allImages = [...topRowImages, ...bottomRowImages];

    const [isOpen, setIsOpen] = useState(false);
    const [current, setCurrent] = useState(0);

    const openModal = (i) => {
        setCurrent(i);
        setIsOpen(true);
    };

    const nextImage = () =>
        setCurrent((prev) => (prev + 1) % allImages.length);

    const prevImage = () =>
        setCurrent((prev) => (prev === 0 ? allImages.length - 1 : prev - 1));


    const heroSettings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1200,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        // pauseOnHover: false,
    };

    const heroImages = [
        // demohero,
        team,
        team2,
        team3,
    ];

    return (
        <div className="life_at_sg_wrapper">
            {/* Hero Section */}
            <section className="life_at_sg_hero">
                <Slider {...heroSettings} className="life_at_sg_hero_slider">
                    {heroImages.map((img, index) => (
                        <div className="life_at_sg_hero_slide" key={index}>
                            <div
                                className="life_at_sg_hero_bg"
                                style={{ backgroundImage: `url(${img})` }}
                            />
                        </div>
                    ))}
                </Slider>

                <div className="life_at_sg_hero_overlay" />

                <div className="life_at_sg_hero_content">
                    <h1 className="life_at_sg_hero_title">
                        At Samriddhi, we don’t hire for positions.
                        <br />
                        <span>We hire for <span className="highlight">purpose,</span><span className="highlight">performance,</span> and <span className="highlight">potential.</span> </span>
                    </h1>

                    <p className="life_at_sg_hero_subtitle">
                        Join our team of visionaries, committed to excellence and purpose
                        <br />
                        {/* We are building people who build legacies. */}
                    </p>

                    <div className="life_at_sg_hero_cta">
                        <button className="life_at_sg_btn_primary">
                            Explore Life at Samriddhi
                        </button>
                        <button className="life_at_sg_btn_secondary">
                            Join the Builders
                        </button>
                    </div>

                    <div className="life_at_sg_scroll_hint">
                        <span />
                        Scroll to discover
                    </div>
                </div>
            </section>


            {/* Value Proposition Section */}
            <section className="life_at_sg_values">
                <div className="life_at_sg_values_inner">

                    <div className="life_at_sg_values_header">
                        <h2 className="life_at_sg_values_title">
                            For Those Who Want More Than a Job
                        </h2>
                        <p className="life_at_sg_values_subtitle">
                            We are not for everyone. We are for people who seek growth over comfort,
                            <br />
                            impact over routine, and legacy over salary.
                        </p>
                    </div>

                    <div className="life_at_sg_values_grid">
                        <div className="life_at_sg_values_card">
                            <h4>Learn & Rise Faster</h4>
                            <p>
                                We design growth. With role-wise training, mentorship, and real
                                responsibility, your learning curve accelerates from day one.
                            </p>
                        </div>

                        <div className="life_at_sg_values_card">
                            <h4>Build What Matters</h4>
                            <p>
                                You don’t just sell or execute—you help create communities, wealth,
                                and lifestyles that last for generations.
                            </p>
                        </div>

                        <div className="life_at_sg_values_card">
                            <h4>Move, Evolve, Lead</h4>
                            <p>
                                Switch roles, take ownership, and grow across projects. Your career
                                here is dynamic, not linear.
                            </p>
                        </div>

                        <div className="life_at_sg_values_card">
                            <h4>Merit Over Hierarchy</h4>
                            <p>
                                At Samriddhi, performance speaks louder than titles. Every individual
                                gets equal opportunity to grow and lead.
                            </p>
                        </div>
                    </div>

                </div>
            </section>


            {/* Life at Samriddhi – Visual Culture */}
            <section className="life_at_sg_gallery">
                <h2 className="life_at_sg_gallery_title">Life at Samriddhi Group</h2>

                {/* Row 1 */}
                <Swiper
                    modules={[FreeMode, Autoplay]}
                    slidesPerView="auto"
                    spaceBetween={20}
                    freeMode={true}
                    grabCursor={true}
                    loop={true}
                    autoplay={{
                        delay: 2200,
                        disableOnInteraction: false,
                    }}
                    speed={600}
                    className="life_at_sg_swiper"
                >
                    {topRowImages.map((img, i) => (
                        <SwiperSlide key={i} className="life_at_sg_swiper_slide">
                            <img
                                src={img}
                                onClick={() => openModal(i)}
                                className="life_at_sg_gallery_img"
                                alt=""
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>


                {/* Row 2 (reverse direction) */}
                <Swiper
                    modules={[FreeMode, Autoplay]}
                    slidesPerView="auto"
                    spaceBetween={20}
                    freeMode={true}
                    grabCursor={true}
                    loop={true}
                    autoplay={{
                        delay: 2400,
                        reverseDirection: true,
                        disableOnInteraction: false,
                    }}
                    speed={600}
                    className="life_at_sg_swiper"
                >
                    {bottomRowImages.map((img, i) => (
                        <SwiperSlide key={i} className="life_at_sg_swiper_slide">
                            <img
                                src={img}
                                onClick={() => openModal(topRowImages.length + i)}
                                className="life_at_sg_gallery_img"
                                alt=""
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>


                {isOpen && (
                    <div className="life_at_sg_gallery_modal">
                        <span className="life_at_sg_modal_close" onClick={() => setIsOpen(false)}>×</span>

                        <div className="life_at_sg_modal_counter">
                            {current + 1} / {allImages.length}
                        </div>

                        <button className="life_at_sg_modal_nav left" onClick={prevImage}>‹</button>
                        <img src={allImages[current]} className="life_at_sg_modal_img" alt="" />
                        <button className="life_at_sg_modal_nav right" onClick={nextImage}>›</button>
                    </div>
                )}
            </section>





            {/* Who We Are Section */}
            {/* <section className="life_at_sg_who">
                <div className="life_at_sg_who_inner">

                    <div className="life_at_sg_who_image">
                        <img
                            src={who}
                            alt="Life at Samriddhi"
                        />
                    </div>

                    <div className="life_at_sg_who_content">
                        <span className="life_at_sg_who_tag">Our Identity</span>

                        <h2 className="life_at_sg_who_title">
                            Who We Are
                        </h2>

                        <p className="life_at_sg_who_text">
                            Samriddhi Group is not just a real-estate company.
                            <br />
                            We are builders of nature-led communities, long-term wealth,
                            and meaningful lifestyles.
                            <br /><br />
                            We operate with the mindset of legacy, not transactions.
                        </p>
                    </div>

                </div>
            </section> */}

            {/* Direct Access to Leaders */}
            <section className="life_at_sg_leaders">
                <div className="life_at_sg_leaders_inner">

                    <div className="life_at_sg_leaders_header">
                        <h2 className="life_at_sg_leaders_title">
                            Work With Leaders, Not Layers
                        </h2>
                        <p className="life_at_sg_leaders_positioning">
                            “A culture of open leadership.”
                        </p>
                    </div>

                    <div className="life_at_sg_leaders_swiper_wrap">
                        <Swiper
                            modules={[Navigation]}
                            navigation
                            spaceBetween={30}
                            slidesPerView={2}
                            speed={700}
                            breakpoints={{
                                0: {
                                    slidesPerView: 1,
                                },
                                768: {
                                    slidesPerView: 2,
                                },
                            }}
                            className="life_at_sg_leaders_swiper"
                        >
                            <SwiperSlide>
                                <div className="life_at_sg_leaders_card">
                                    <img src={foundersession} alt="" />
                                    <h4>Monthly Founder Sessions</h4>
                                    <p>Open conversations with founders on vision, direction, and growth.</p>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="life_at_sg_leaders_card">
                                    <img src={Strategy} alt="" />
                                    <h4>Strategy Rooms, Not Silos</h4>
                                    <p>Be part of real discussions that shape projects and decisions.</p>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="life_at_sg_leaders_card">
                                    <img src={qa} alt="" />
                                    <h4>Live Q&A & Decision Exposure</h4>
                                    <p>Understand how leaders think, decide, and act in real time.</p>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="life_at_sg_leaders_card">
                                    <img src={builders} alt="" />
                                    <h4>Learn From Builders</h4>
                                    <p>Work alongside people who have built, failed, learned, and built again.</p>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>

                </div>
            </section>


            {/* More Than Work. A Way of Becoming */}
            <section className="life_at_sg_becoming">
                <div className="life_at_sg_becoming_inner">

                    <div className="life_at_sg_becoming_header">
                        <h2 className="life_at_sg_becoming_title">
                            More Than Work. <span>A Way of Becoming.</span>
                        </h2>
                        {/* <p className="life_at_sg_becoming_subtitle">
                            We don’t just build projects. <br />
                            We build people—from the inside out.
                        </p> */}
                    </div>

                    <div className="life_at_sg_becoming_grid">

                        {/* Inner Growth */}
                        <div className="life_at_sg_becoming_block">
                            <div className="life_at_sg_becoming_image">
                                <img src={meditation} alt="Inner Growth at Samriddhi" />
                            </div>
                            <h3>Samriddhi Inner Development</h3>
                            <ul>
                                <li>Weekly yoga & breathwork</li>
                                <li>Mindfulness & focus workshops</li>
                                <li>Stress management</li>
                                <li>Emotional intelligence sessions</li>
                                <li>Reflection circles</li>
                            </ul>
                        </div>

                        {/* Culture Rituals */}
                        <div className="life_at_sg_becoming_block">
                            <div className="life_at_sg_becoming_image">
                                <img src={culture} alt="Culture Rituals at Samriddhi" />
                            </div>
                            <h3>Culture Rituals</h3>
                            <ul>
                                <li>Samriddhi Fridays – bonding & wins</li>
                                <li>Founder Fridays – open conversations</li>
                                <li>Project Days – site visits together</li>
                                <li>Learning Hours – skill sharing</li>
                                <li>Celebration Circles – milestones & birthdays</li>
                            </ul>
                        </div>

                    </div>
                </div>
            </section>


            {/* Message to Future Team Members */}
            <section className="life_at_sg_message">
                <div className="life_at_sg_message_inner">
                    <h2 className="life_at_sg_message_title">
                        Our Message to Future Team Members
                    </h2>

                    <p className="life_at_sg_message_text">
                        If you seek comfort, Samriddhi is not for you.
                        <br />
                        If you seek growth, meaning, and the opportunity to build something that
                        outlives you —
                        <span> welcome home.</span>
                    </p>

                    <div className="life_at_sg_message_cta">
                        <Link to='/all-jobs'><button className="life_at_sg_btn_primary">Explore Open Roles</button></Link>

                    </div>
                </div>
            </section>




        </div>
    );
};

export default LifeAtSG;
